module.exports = __webpack_public_path__ + "static/media/mom_no_heart.d5f81a25.png";